/* eslint-disable react/button-has-type */
import PropTypes from 'prop-types';
import React from 'react';

import IconDelete from '../Icons/IconDelete';

import './index.scss';

const ItemBox = ({ ariaLabel, displayButton, buttonHandler, buttonId, title, body }) => {
  const removeAriaLabel = `remove ${ariaLabel}`;

  return (
    <li className="item-box" aria-label={ariaLabel}>
      <div>
        <p className="item-box__title desktop-d-body">{title}</p>
        {body && <div className="item-box__body">{body}</div>}
      </div>
      <div>
        {displayButton && (
          <button
            type="button"
            onClick={buttonHandler}
            aria-label={removeAriaLabel}
            id={buttonId}
            className="delete-button"
          >
            <IconDelete />
          </button>
        )}
      </div>
    </li>
  );
};

ItemBox.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  displayButton: PropTypes.bool.isRequired,
  buttonHandler: PropTypes.func.isRequired,
  buttonId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.node,
};

export default ItemBox;
